var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpgDocs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.453,3.453C18.946,2.947 18.266,2.667 17.56,2.667H8C6.533,2.667 5.333,3.867 5.333,5.333V26.667C5.333,28.133 6.52,29.333 7.986,29.333H24C25.466,29.333 26.666,28.133 26.666,26.667V11.773C26.666,11.067 26.386,10.387 25.88,9.893L19.453,3.453ZM20,24H12C11.266,24 10.666,23.4 10.666,22.667C10.666,21.933 11.266,21.333 12,21.333H20C20.733,21.333 21.333,21.933 21.333,22.667C21.333,23.4 20.733,24 20,24ZM20,18.667H12C11.266,18.667 10.666,18.067 10.666,17.333C10.666,16.6 11.266,16 12,16H20C20.733,16 21.333,16.6 21.333,17.333C21.333,18.067 20.733,18.667 20,18.667ZM17.333,10.667V4.667L24.666,12H18.666C17.933,12 17.333,11.4 17.333,10.667Z",
    fill: "#55A7F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpgDocs);
export default __webpack_public_path__ + "static/media/spgDocs.a9a5510e85700fb64a84ae73feede1b9.svg";
export { ForwardRef as ReactComponent };